import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { checklist } from '../data/offer';
export function ChecklistSection() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="includes-title" data-id="element-47" data-mp="2zvh1wlr1mc0c">
      <div className="mx-auto max-w-5xl px-4" data-id="element-48" data-mp="2m06e1sb7ur5h">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-49" data-mp="2qwdlxqn6acq2">Siempre incluidos · siempre gratis</p>
        <h2 id="includes-title" className="mt-3 text-center text-3xl font-extrabold text-field sm:text-4xl" data-id="element-50" data-mp="2c6plssqq9k3x">Todos los tomos incluyen</h2>
        <div className="mt-9 grid gap-x-10 gap-y-4 md:grid-cols-2" data-id="element-51" data-mp="237kn9mf61qrr">
          {checklist.map(([title, detail], index) => <motion.div key={title} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.02,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 border-b border-line py-3" data-id="element-52" data-mp="278wbbnie63xu" data-mpi={index}>
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-field" data-id="element-53" data-mp="1iuhhl3ctv50e">
                <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-54" data-mp="1rtcm8b08471l" />
              </span>
              <p data-id="element-55" data-mp="1mu8dtml4idcb">
                <b className="block text-sm text-ink" data-id="element-56" data-mp="1mtqdadrfhcyl">{title}</b>
                <span className="text-sm text-muted" data-id="element-57" data-mp="1msf7k8ef9v4u">{detail}</span>
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}